const domains = {
  respiratorio: "https://equipamentosrespiratorios.biancoazure.com.br",
  homecare: "https://homecare.biancoazure.com.br",
  auditivo: "https://aparelhosauditivos.biancoazure.com.br",
  institucional: "https://biancoazure.com.br",
};

export default domains;